import { USERS } from "../../Constants/Endpoints";
import { ApiRequestInterceptor } from "../apiRequest";

export const fetchChangePassword = async (username, newPassword) => {
  const response = await ApiRequestInterceptor(
    USERS.changePassword,
    "PUT",
    { username, newPassword }
  );

  if (response.code === 200) return response;

  const errorMessage = response?.data?.error || "Error al cambiar contraseña";
  throw new Error(errorMessage);
};
